import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createDeleteRoleUseCase({ membershipRepository }: Deps) {
  return async function deleteRole(id: string): Promise<void> {
    return membershipRepository.deleteRole(id);
  };
}
